<template>
  <div>
    <br />

    <vue-action-buttons :buttons="actionButtons" />

    <vue-delivery-details :delivery="delivery" :reference="$route.params.reference" />

    <br>

    <vue-data-table v-if="delivery.orders" :headers="headers" :data="delivery.orders" :items-per-page="10"
      :buttons="buttons">

      <template #cell-totalPriceTTC="{ row }">
        <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
          :class="row.totalPriceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #cell-validated="{ row }">
        <span class="px-2 py-1 rounded  "
          :class="row.validated == 'Validé' ? 'bg-light-success text-success' : 'bg-light-danger text-danger'">
          {{ row.validated }}
        </span>
      </template>


      <template #cell-passPermit="{ row }">
        <span class="px-2 py-1 rounded  ">
          {{ row.passPermit ? "LP" + row.passPermit : "Non livré" }}
        </span>
      </template>

      <template #cell-remark="{ row }">
        <span v-show="row.remark" class="px-2 py-1 rounded  " :class="row.remark ? 'bg-light-info text-info' : ''">
          <i class="bi bi-exclamation-circle-fill"></i>
        </span>
      </template>

      <template #footer-totalPriceTTC="{ column, sum }">
        <span v-show="$userRole != 'Magasinier'" class="fw-bold text-success">
          {{ sum }}
        </span>
      </template>

    </vue-data-table>
    <br />
    <br />
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { field: 'reference', label: 'Référence', class: '' },
        { field: 'customerFullName', label: 'Nom Complet', class: '' },
        { field: 'customerCity', label: 'Ville', class: '' },
        { field: 'date', label: 'Date', class: '' },
        { field: 'totalPriceTTC', label: ' Total', class: 'fw-bold' },
        { field: 'totalQuantity', label: 'Total Qté', class: 'fw-bold' },
        { field: 'validated', label: 'Etat', class: '' },
        { field: 'passPermit', label: 'LP', class: '' },
        { field: 'remark', label: 'NB', class: '' },
        { field: 'userFullName', label: 'Créer par', class: '' },
      ],
      // Button actions
      buttons: [
        {
          label: 'Détails',
          icon: 'bi bi-info-square',
          class: 'btn btn-primary',
          action: (order) => {
            this.$router.push({
              name: 'orders-details',
              params: { reference: order.reference },
            });
          },
        },
      ],
      // Summable columns
      summableColumns: [
        { field: 'totalPriceTTC', class: 'fw-bold' },
        { field: 'totalQuantity', class: 'fw-bold' },
      ],

      actionButtons: [
        {
          label: "Valider",
          class: "btn btn-outline-success",
          icon: "bi bi-check2-square",
          action: () => this.addDeliveryToSale(this.reference),
          condition: () => this.delivery.validated != true,
        },
        {
          label: "Modifier",
          class: "btn btn-outline-primary",
          icon: "bi bi-pencil-square",
          action: () => this.editDelivery(this.delivery.reference),
          
        },
        {
          label: "Expédié",
          class: "btn btn-outline-info",
          icon: "bi bi-truck",
          action: () => this.markAsExit(this.reference),
        },


        {
          label: "Ticket de Livraison",
          class: "btn btn-outline-secondary",
          icon: "bi bi-printer",
          action: () => this.printDeliveryReceipt(this.reference),
          condition: () => this.$userRole === 'Admin' || this.$userRole === 'Magasinier' || this.$userRole === 'Commercial',
        },

        {
          label: "Supprimer",
          class: "btn btn-outline-danger",
          icon: "bi bi-trash",
          action: () => this.remove(this.reference),
          condition: () => (this.$userRole === 'Admin' || this.$userRole === 'Commercial') && this.delivery.validated == false,
        },

        {
          label: "Actualiser",
          class: "btn btn-outline-dark",
          icon: "bi bi-arrow-clockwise",
          action: this.refresh,
        },
      ],
      reference: this.$route.params.reference
    };
  },

  async mounted() {
    await this.$store.dispatch("delivery/show", this.$route.params.reference);
  },
  computed: {
    ...mapGetters("delivery", {
      delivery: "getDelivery",
    }),
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("delivery/show", this.$route.params.reference);
    },
    async printPurchaseDelivery(reference) {
      await this.$store.dispatch("delivery/printPurchaseDeliveryPage", reference);
    },

    async printDeliveryReceipt(reference) {
      await this.$store.dispatch("delivery/printDeliveryReceipt", reference);
    },

    async printBill(reference) {
      await this.$store.dispatch("delivery/printBillPage", reference);
    },

    async addDeliveryToSale(reference) {
      await this.$store.dispatch("delivery/addToSale", reference);
    },

    async remove(reference) {
      await this.$store.dispatch("delivery/destroy", reference);
    },

    editDelivery(ref) {
      this.$router.push({ name: "deliveries-edit", params: { reference: ref } });
    },
    async markAsExit(reference) {
      await this.$store.dispatch("delivery/markAsExit", reference);
    },

    async cancelDelivery(reference) {
      await this.$store.dispatch("delivery/cancelDelivery", reference);
    },

    formatDate(value) {
      if (!value) return null;
      return moment(value).format("DD-MM-YYYY");
    },
    formatTime(value) {
      if (!value) return null;
      return moment(value).format("HH:mm"); // Correction du format d'heure
    }

  },
};
</script>
